/**
 * CANG / BlackRedAngus: one display group per COL paint-band letter.
 * ILR2 does not ship group captions — these names describe the traits sharing
 * each i4 colour band (GGGGAAGAAARRRRYYYYYYYYABBB).
 *
 * Values must match {@link EBV_CATEGORY} in ebvColumns.tsx (string literals
 * avoid a circular import).
 */
export const BLACK_RED_ANGUS_COLOUR_SLOT_CATEGORY: Record<string, string> = {
  /** Calving ease, birth–yearling weights, scrotal (positions 1–4, 7). */
  G: 'Growth',
  /** RADG, DMI, docility, claw, angle, CBI (positions 5–6, 8–10, 23). */
  A: 'Conformation',
  /** Carcass weight, marbling, REA, fat (positions 11–14). */
  R: 'Carcass',
  /** HPG, mat calving, milk, mature size, longevity, teat, udder (15–22). */
  Y: 'Maternal',
  /** Index columns (positions 24–26, display 2). */
  B: 'Indexes',
  F: 'Indexes',
};

/** CANG group header / cell tints — one colour per display category. */
export const BLACK_RED_ANGUS_CATEGORY_TINT: Record<string, string> = {
  Growth: '#86EFAC',
  Conformation: '#7DD3FC',
  Carcass: '#FCA5A5',
  Maternal: '#FDE047',
  Indexes: '#D8B4FE',
};

/** COL letter → tint (same palette as {@link BLACK_RED_ANGUS_CATEGORY_TINT}). */
export const BLACK_RED_ANGUS_COLOUR_SLOT_TINT: Record<string, string> = {
  G: '#86EFAC',
  A: '#7DD3FC',
  R: '#FCA5A5',
  Y: '#FDE047',
  B: '#D8B4FE',
  F: '#D8B4FE',
};
